import React, { useState } from "react";
// import Slider from "react-slick";
import productData from "../data/products.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "./ProductCard";

const Productlistcard = () => {
  const [products] = useState(
    productData.products.filter((product) => product.productstatus === "Active")
  );

  // const sliderSettings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: "unslick",
  //     },
  //   ],
  // };

  return (
    <section className="py-4 px-2 md:px-8 lg:px-16 bg-white">
      {/* Mobile Slider 
      <div className="block md:hidden">
        <Slider {...sliderSettings}>
          {products.map((product) => (
            <div key={product.id} className="px-2">
              <ProductCard product={product} />
            </div>
          ))}
        </Slider>
      </div>*/}

      {/* Grid for larger screens */}
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 md:gap-8">
        {products.map((product) => (
          <div key={product.id} className="sm:mt-8">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Productlistcard;
